import { render, staticRenderFns } from "./one.vue?vue&type=template&id=e56d849e&scoped=true"
import script from "./one.vue?vue&type=script&lang=ts"
export * from "./one.vue?vue&type=script&lang=ts"
import style0 from "./one.vue?vue&type=style&index=0&id=e56d849e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56d849e",
  null
  
)

export default component.exports